module.exports = __webpack_public_path__ + "static/media/explore_05.deaab2e3.jpg";